import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { ReactComponent as CartIcon } from '@ts/images/icons/icon-cart.svg';
import { ReactComponent as HeartIcon } from '@ts/images/icons/heart-icon.svg';

const CircleIcons = {
    cart: <CartIcon />,
    heart: <HeartIcon />,
};

const CircleIconButton = styled.button.attrs((props) => ({
    inverted: props.inverted ? 1 : 0,
    children: CircleIcons[props.icon] ? CircleIcons[props.icon] : props.children,
}))`
    width: 40px;
    height: 40px;
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0 0 0 17px;
    outline: none;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 1;
        cursor: pointer;
    }

    ${(props) =>
        props.inverted &&
        css`
            opacity: 1;
            &:hover {
                opacity: 0.5;
            }
        `}
`;

export default CircleIconButton;

CircleIconButton.propTypes = {
    icon: PropTypes.oneOf(Object.keys(CircleIcons)),
    inverted: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};
